module.exports = __webpack_public_path__ + "img/right-arrow.843ccef2.svg";